
import { evaluateQueryStringBooleanParameter } from '../../helpers/utils';

const Constants = {   // REVIEW obtener de ./Configuration.js
  '360_Modes': {
    monoscopic: 'monoscopic',
  },
};

const QueryKeys = {
  360: '360',
  controls: 'controls',
  autoplay: 'autoplay',
  autostart: 'autostart',
  loop: 'loop',
  repeat: 'repeat',
  mute: 'mute',
  injectSrc: 'injectSrc',
  injectsrc: 'injectsrc',
  miniature: 'miniature',
};

const QueryStrings = {

  overrideConfiguration: (configuration = {}, queryParams) => {
    // console.log( 'controllers::custom-3-player::QueryStrings::overrideConfiguration - configuration: ', configuration, ', queryParams: ', queryParams);    // DEBUG
    const { custom_3_playerConfiguration = {} } = configuration;
    const { playlist, customProps = {} } = custom_3_playerConfiguration;

    if( QueryKeys[360] in queryParams) playlist?.forEach( media => {
      media.stereomode = queryParams[ QueryKeys[360]] ?  queryParams[ QueryKeys[360]] : Constants['360_Modes'].monoscopic;
    });

    if( QueryKeys.controls in queryParams) customProps.controls = evaluateQueryStringBooleanParameter( queryParams[ QueryKeys.controls]);
    if( QueryKeys.autoplay in queryParams) customProps.autostart = evaluateQueryStringBooleanParameter( queryParams[ QueryKeys.autoplay]);
    if( QueryKeys.autostart in queryParams) customProps.autostart = evaluateQueryStringBooleanParameter( queryParams[ QueryKeys.autostart]);
    if( QueryKeys.loop in queryParams) customProps.repeat = evaluateQueryStringBooleanParameter( queryParams[ QueryKeys.loop]);
    if( QueryKeys.repeat in queryParams) customProps.repeat = evaluateQueryStringBooleanParameter( queryParams[ QueryKeys.repeat]);
    if( QueryKeys.mute in queryParams) customProps.mute = evaluateQueryStringBooleanParameter( queryParams[ QueryKeys.mute]);

    if( QueryKeys.injectSrc in queryParams) playlist?.forEach( media => {
      media.file = queryParams[ QueryKeys.injectSrc];
    });
    if( QueryKeys.injectsrc in queryParams) playlist?.forEach( media => {
      media.file = queryParams[ QueryKeys.injectsrc];
    });
    if( QueryKeys.miniature in queryParams) playlist?.forEach( media => {
      media.image = queryParams[ QueryKeys.miniature];
    });

    return configuration;
  },

};

export default QueryStrings;
